export default "__VITE_ASSET__DWuYQiUe__"